// extracted by mini-css-extract-plugin
export default {"loadingContainer":"tenantUserDetail_loadingContainer__sKRYi","container":"tenantUserDetail_container__LL89t","section":"tenantUserDetail_section__UwVh3"};